import { render, staticRenderFns } from "./departmentSetting.vue?vue&type=template&id=6a257aa3&scoped=true&"
import script from "./departmentSetting.vue?vue&type=script&lang=js&"
export * from "./departmentSetting.vue?vue&type=script&lang=js&"
import style0 from "./departmentSetting.vue?vue&type=style&index=0&id=6a257aa3&prod&lang=scss&scoped=true&"
import style1 from "./departmentSetting.vue?vue&type=style&index=1&id=6a257aa3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a257aa3",
  null
  
)

export default component.exports